import { loginApi } from '../api';

type LoginResponse = string;

interface LoginRequest {
  email: string;
  password: string;
  token?: string;
  trusted?: boolean;
}

interface RateLimitingData {
  attempts: {
    allowed: number;
    left: number;
    window: {
      unit: string;
      value: number;
    };
  };
}

export interface LoginInvalidCredentialsErrorResponse {
  meta: RateLimitingData;
}

export interface LoginTooManyAttemptsErrorResponse {
  meta: RateLimitingData;
}

const login = async (loginRequest: LoginRequest) => {
  if (__CONFIG__.waf.challenge_enabled && await window.AwsWafIntegration.hasToken()) {
    const headers = { 'x-aws-waf-token': await window.AwsWafIntegration.getToken() };

    return loginApi.post<LoginResponse>('/users.login', loginRequest, headers);
  }

  return loginApi.post<LoginResponse>('/users.login', loginRequest);
};

export default login;
